export default {
  payWelfareText: 'Benefícios de recarga',
  blackFridayDiscount: 'Desconto cronometrado da Black Friday',
  shareGift: 'Compartilhar Presente',
  vipWeeklyWelfare: 'Desconto Semanal VIP',
  exchangeCoupon: 'Cupom',
  firstPayOff: 'Até 15% de Desconto na 1ª compra',
  blackFridayEvent: 'Evento de Black Friday',
  limitedTimeOff: '10% de desconto por Tempo Limitado',
  claimCoupon: 'Resgate agora',
  blackFridayTimedCoupon: 'Cupom de Black Friday por tempo limitado',
  timeLeft: 'Tempo restante:',
  claimTimeCoupon: 'Solicite cupom de 10% de desconto agora!',
  points: 'Pontos: ${point}',
  costPointTip: 'Troque pontos por cupons',
  maxPointTip: 'Cada conta pode usar até 500 pontos.',
  discountOff: '10% DE DESCONTO',
  highestDiscount: 'ATÉ  ${discount} DE DESCONTO',
  needPoint: 'Requer ${point} pontos',
  changeCurrency: 'Alterar moeda',
  claim: 'Resgatar',
  claimSucc: 'Resgatado',
  claimFail: 'Falhou',
  pointNotEnough: 'Pontos insuficientes',
  afterClaimPoint: 'Pontos restantes: ${point}',
  footTips1: 'Apenas 1 cupom pode ser usado para cada pedido.',
  footTips2: 'O cupom não pode ser usado para comprar moedas/tokens no jogo.',
  footTips3: 'Reservamo-nos o direito da interpretação final deste evento.',
  ruleTitleText: 'Regras do Evento',
  ruleTime:
    'Duração do evento: 00h00 de 24 de novembro de 2023 até 23h59 de 26 de novembro de 2023 (UTC)',
  bfRuleText1:
    '1. 400 pontos serão concedidos à sua conta quando você fizer login na página oficial de recarga pela primeira vez durante o evento. Você pode trocar até 500 pontos por cupons.',
  bfRuleText2:
    '2. Você poderá trocar pontos da Black Friday por cupons durante o evento.',
  bfRuleText3:
    '3. Você só poderá utilizar 1 cupom por cada pedido. Os cupons não podem ser usados para comprar moedas/tokens no jogo.',
  bfRuleText4: '4. Para transações, aceitamos apenas as seguintes moedas:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Você não pode alterar a moeda após a transação ser realizada. Os pontos trocados não podem ser reembolsados.',
  bfRuleText6: '6. Os cupons da Black Friday serão válidos apenas por 7 dias.',
  bfRuleText7: '7. Reservamo-nos o direito da interpretação final deste evento.',
  thanksTip:
    'Obrigado pela sua participação. Participe da nossa comunidade oficial para obter mais informações sobre o evento.',
  exchangePoints: 'Trocar',
  exchangeCode: 'Insira o código de troca.',
  enterExchangeCode: 'Insira o código de troca.',
  exchangeText: 'Trocar',
  confirmGet: 'Confirmar',
  couponUsedWay:
    'O cupom só pode ser usado com moedas específicas. Confirme sua moeda.',
  confirmText: 'Confirmar',
  exchangeSucc: 'Trocado',
  aboutCoins: 'Sobre moedas/tokens no jogo',
  aboutCoinsText:
    'Você pode trocar moedas/tokens do jogo por todos os pacotes e privilégios, exceto pela própria moeda/token do jogo.',
  known: 'OK',
  codeText: 'Código',
  codeInvalid: 'Código inválido!',
  hasExchanged: 'Você não pode resgatar mais códigos.',
  hideText: 'Esconder',
  //黑五的报错码
  'bf-20001': 'Não logado',
  'bf-20002': 'Erro de parâmetro. Tente entrar novamente no evento.',
  'bf-20003': 'Pontos insuficientes',
  'bf-20004':
    'Falha. Tente novamente mais tarde ou entre em contato com o Suporte ao Cliente.',
  'bf-20005': 'Resgatado',
  'bf-20015': 'O evento não está disponível no momento.',
  'bf-20016': 'O evento terminou.',
  bfShareText: 'Solicite cupom de 10% de desconto agora!',
  rightsCenterBtn: 'Centro de Membros Premium',
  payBtn: 'RECARGA',
  hasEqualRewardMuglo: 'Até 1800 diamantes de BÔNUS na recarga do site oficial!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Extraordinário Glorioso (Permanente)',
  rightCenterNoticeTitle: 'Sistema de Pontos VIP está sendo atualizado para o Centro de Privilégios',
  rightCenterNoticeContent: "Saudações, Comandante!<br />Obrigado por seu apoio contínuo. Para proporcionar uma experiência de recompensas ainda melhor, o atual Sistema de Pontos VIP será atualizado para o novo Centro de Privilégios em 26 de junho de 2025. Esse novo sistema não apenas consolidará os benefícios VIP existentes, mas também introduzirá uma série de novos benefícios empolgantes. Veja o que você precisa saber:<br />1. O que está mudando?<br />Os benefícios de login semanal permanecem<br />De 26 de junho a 9 de julho de 2025, os jogadores podem continuar a reivindicar Cupons VIP Semanais fazendo login na Página Oficial de Recarga. O número de cupons permanecerá o mesmo do evento Ponto VIP. Enquanto isso, os jogadores também poderão resgatar novos cupons no Centro de Privilégios, que incluirá um limite máximo de desconto. Para detalhes completos sobre as novas regras de cupons e limites de resgate, consulte a tabela no final deste aviso.<br />Nota: O recurso de resgate automático de cupons deve ser ativado manualmente. Para fazer isso, vá para: Página Inicial do Centro de Privilégios > Benefícios para Membros > Ativar Resgate Automático de Cupons > Selecionar Cupons para Resgate Automático > Confirmar.<br />Novo Recurso de Troca de Pontos<br />O Centro de Privilégios oferecerá um recurso de Troca de Pontos. Ganhe pontos fazendo login no jogo ou concluindo tarefas designadas e, em seguida, troque-os por cupons exclusivos, itens raros e outras recompensas valiosas. (Consulte a página do Centro de Privilégios para limites de resgate de itens.)<br />Herança de Nível VIP<br />Seu nível VIP atual e Pontos VIP acumulados serão totalmente transferidos para o novo sistema. Você será automaticamente atribuído ao nível correspondente do Centro de Privilégios, e todos os seus benefícios VIP atuais serão mantidos - e até aprimorados.<br />2. Por Que Esse Aprimoramento é Melhor<br />Benefícios Mais Claros: Todas as regras de recompensa e detalhes de resgate são exibidos claramente, tornando mais fácil do que nunca reivindicar seus benefícios.<br />Recompensas Maiores: Desfrute de novos eventos de troca de pontos e itens de alto valor atualizados regularmente.<br />Sorteios: Além da troca de pontos, eventos de sorteio também estarão disponíveis, dando a você chances de ganhar valiosos itens dentro do jogo.<br />3. Notas Importantes<br />Durante o período de transição (26 de junho a 9 de julho de 2025), a seção original de Pontos VIP será gradualmente eliminada. Você ainda poderá receber e usar cupons normalmente durante esse período. Certifique-se de usar os cupons restantes antes do término do Evento de Pontos VIP - os cupons não utilizados expirarão assim que for encerrado.<br />Após o lançamento do Centro de Privilégios, você poderá acessá-lo em: Centro de Recarga Oficial > Toque no Seu Avatar > Centro de Privilégios",
  rightCenterNoticeTableTitle: 'Comparação de alterações de cupom',
  rightCenterNoticeTableHeader1: 'Requisitos de Resgate - Nível de Associação Premium',
  rightCenterNoticeTableHeader2: 'Nível VIP original',
  rightCenterNoticeTableHeader3: 'Desconto do cupom',
  rightCenterNoticeTableHeader4: 'Limite de Aquisição',
  rightCenterNoticeTableHeader5: 'Limite Máximo de Desconto',
  rightCenterNoticeTableLevel1: 'Bronze',
  rightCenterNoticeTableLevel2: 'Prata',
  rightCenterNoticeTableLevel3: 'Ouro',
  rightCenterNoticeTableLevel4: 'Platina',
  rightCenterNoticeTableLevel5: 'Diamante',
  rightCenterNoticeTableCount1: 'Uma vez por dia',
  rightCenterNoticeTableCount2: '15 Vezes/Mês',
  rightCenterNoticeTableCount3: '10 Vezes/Mês',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Nota: Os limites de desconto de cupom no Centro de Privilégios são baseados em USD (Dólares) e podem variar com as taxas de câmbio. O valor real do desconto será exibido na página de uso.',
  '-': '-'
};
